<!-- 记录汇总 -->
<template>
   <div>
      <el-dialog title="按条件过滤记录" :visible.sync="dialogTableVisible" v-if="dialogTableVisible" width="800px">
         <el-table v-loading="loading" size="mini" :data="allFieldList" height="500" border style="width: 100%">
            <el-table-column prop="fieldShow" label="列名称">
               <!-- <template slot-scope="scope">
                    </template> -->
            </el-table-column>
            <el-table-column prop="" label="关系">
               <template slot-scope="scope">
                  <el-select clearable size="mini" v-model="scope.row.operator" v-if="scope.row.fieldType == 'number' || scope.row.fieldType == 'date'|| scope.row.fieldType == 'formatter'" placeholder="请选择">
                     <el-option label="大于" value="1"></el-option>
                     <el-option label="大于等于" value="2"></el-option>
                     <el-option label="等于" value="3"></el-option>
                     <el-option label="小于" value="4"></el-option>
                     <el-option label="小于等于" value="5"></el-option>
                     <el-option label="不等于" value="10"></el-option>
                  </el-select>
                  <el-select clearable size="mini" v-model="scope.row.operator" v-else placeholder="请选择">
                     <el-option label="左匹配" value="6"></el-option>
                     <el-option label="右匹配" value="7"></el-option>
                     <el-option label="模糊查询" value="8"></el-option>
                     <el-option label="等于" value="9"></el-option>
                     <el-option label="不等于" value="11"></el-option>
                  </el-select>
               </template>
            </el-table-column>
            <el-table-column prop="" label="输入值">
               <template slot-scope="scope">
                  <el-date-picker v-if="scope.row.fieldType == 'date'" size="mini" v-model="scope.row.opValue" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期">
                  </el-date-picker>
                  <el-select clearable size="mini" v-model="scope.row.opValue" v-else-if="scope.row.fieldType == 'formatter'" placeholder="请选择">
                     <el-option v-for="(item,index) in JSON.parse(scope.row.formatterContent)" :key="index" :label="item.value" :value="item.key"></el-option>
                  </el-select>
                  <el-input type="text" v-else v-model="scope.row.opValue" clearable></el-input>
               </template>
            </el-table-column>
         </el-table>
         <div slot="footer" class="dialog-footer">
            <el-button @click="dialogTableVisible = false">取 消</el-button>
            <el-button type="primary" @click="sendDataAction">确 定</el-button>
         </div>
      </el-dialog>
      <summaryReport ref="summaryReport"></summaryReport>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
   name: "recordFiltering",
   props: ["actionData"],
   data() {
      //这里存放数据
      return {
         dialogTableVisible: false,
         multipleSelection: [],
         orderData: [],
         fileIds: [],
         fileType: false,
         printSource: '',
         strSelect: [],
         numSelect: [],
         numberField: [],
         stringField: [],
         list: [],
         selString: [],
         selNumber: [],
         dialogTableVisible1: false,
         allFieldList: [],
         dataShow: [],
         totalField: [],
         dateField: [],
         excelData: [],
         rpcName: '',
         strSel: '',
         numSel: '',
         loading: false
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {},
   //方法集合
   methods: {
      sendDataAction() {
         this.loading = true
         let newFieldList = []
         this.allFieldList.forEach(keys => {
            if (keys.operator != '' && keys.operator && (keys.opValue != '' || keys.opValue == 0) && (keys.opValue || keys.opValue == 0)) {
               newFieldList.push(keys)
            }
         })
         this.multiFilter(this.list, newFieldList)

         // this.dialogTableVisible1 = true
      },
      multiFilter(array, newFieldList) {
         let newData = []
         // filters all elements passing the criteria fieldEntity
         array.forEach((item) => { //报表数据
            let flag = true
            for (let index = 0; index < newFieldList.length; index++) {
               const keys = newFieldList[index];
               console.log(keys.operator, item[keys.fieldEntity], keys, keys.opValue)
               let flag1 = true
               let flag2 = true
               let flag3 = true
               let flag4 = true
               let flag5 = true
               let flag6 = true
               let flag7 = true
               let flag8 = true
               let flag9 = true
               let flag10 = true
               let flag11 = true
               let endDate = ""
               if (keys.fieldType == 'date') {
                  endDate = keys.opValue + 24 * 60 * 60 * 1000 - 1
               }
               if (keys.operator == 1) { //operator 操作符  条件 就是大于等于的value
                  if (keys.fieldType == 'date') {
                     if (!(item[keys.fieldEntity] > endDate)) {
                        flag1 = false
                     }
                  } else {
                     if (!(item[keys.fieldEntity] > keys.opValue)) {
                        flag1 = false
                     }
                  }
               } else if (keys.operator == 2) {
                  if (!(item[keys.fieldEntity] >= keys.opValue)) {
                     flag2 = false
                  }
               } else if (keys.operator == 3) {
                  if (keys.fieldType == 'date') {
                     if (!(item[keys.fieldEntity] >= keys.opValue)) {
                        if (!(item[keys.fieldEntity] <= endDate)) {
                           flag3 = false
                        }
                     }
                  } else {
                     if (!(item[keys.fieldEntity] == keys.opValue)) {
                        flag3 = false
                     }
                  }
               } else if (keys.operator == 4) {
                  if (!(item[keys.fieldEntity] < keys.opValue)) {
                     flag4 = false
                  }
               } else if (keys.operator == 5) {
                  if (keys.fieldType == 'date') {
                     if (!(item[keys.fieldEntity] <= endDate)) {
                        flag5 = false
                     }
                  } else {
                     if (!(item[keys.fieldEntity] <= keys.opValue)) {
                        flag5 = false
                     }
                  }
               } else if (keys.operator == 6) {
                  if (item[keys.fieldEntity].substr(0, 1) != keys.opValue.substr(0, 1)) {
                     flag6 = false
                  }
               } else if (keys.operator == 7) {
                  if (item[keys.fieldEntity].substr(item[keys.fieldEntity].length - 1, 1) != keys
                     .opValue.substr(keys
                        .opValue.length - 1, 1)) {
                     flag7 = false
                  }
               } else if (keys.operator == 8) {

                  if (!(item[keys.fieldEntity].indexOf(keys.opValue) != -1)) {
                     flag8 = false
                  }
               } else if (keys.operator == 9) {
                  if (item[keys.fieldEntity] != keys.opValue) {
                     flag9 = false
                  }
               } else if (keys.operator == 10) { // 不等于（数值/日期）
                  if (keys.fieldType == 'date') {
                     if (item[keys.fieldEntity] >= keys.opValue && item[keys.fieldEntity] <= endDate) {
                        flag10 = false
                     }
                  } else {
                     if (item[keys.fieldEntity] == keys.opValue) {
                        flag10 = false
                     }
                  }
               } else if (keys.operator == 11) { // 不等于（文本）
                  if (item[keys.fieldEntity] == keys.opValue) {
                     flag11 = false
                  }
               }
               if (flag1 && flag2 && flag3 && flag4 && flag5 && flag6 && flag7 && flag8 &&
                  flag9 && flag10 && flag11) {
                  flag = true
               } else {
                  flag = false
                  break
               }
               // 想着11个flag状态控制 如果全部满足条件 return这条数据
            }
            if (flag) {
               newData.push(item)
            }
         })
         this.dataShow = JSON.parse(JSON.stringify(newData))
         this.loading = false
         if (this.dataShow.length == 0) {
            return this.$message({
               message: '暂无匹配数据!',
               type: 'warning'
            });
         }
         let reportInfo = {
            allFieldList: this.allFieldList,
            dataShow: this.dataShow,
            rpcName: this.rpcName,
            count: this.list.length,
            type: 'gl'
         }

         this.$refs.summaryReport.openBox(reportInfo)
      },

      openBox(data) {
         console.log(data);
         this.allFieldList = []
         data.nowFieldJur.forEach(item => {
            // item.operator = ''
            // item.opValue = ''
            if (item.isShow == 1) this.allFieldList.push(item)
         });
         console.log(this.allFieldList)
         this.list = data.list
         this.numSelect = []
         this.strSelect = []
         this.rpcName = data.rpcName + '过滤报表'
         this.dialogTableVisible = true
      },
      tableRowClassName({
         row,
         rowIndex
      }) {
         if (row.color) return row.color;
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.printSource = sessionStorage.getItem('printSource').replace(/\"/g, "");
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.totalBox {
   width: 230px;
}

.dis {
   display: flex;
}

.checkBox {
   border: 1px solid #dcdfe6;
   padding: 10px;
}

::v-deep .el-checkbox.is-bordered.el-checkbox--mini {
   width: 210px;
   margin-left: 0;
}
</style>